<template>
  <div class="descpopup">
    <van-popup v-model="show_desc" position="bottom" round closeable :style="{ height: '70%' }">
      <div class="showDesc" v-if="descObj">
        <!-- 问题名称 -->
        <div class="showDesc_title" v-if="descObj.indexNum"><span v-if="descObj.indexNum">{{descObj.indexNum}}. </span>{{descObj.question.question}}</div>

        <!-- 答案项图片 -->
        <div class="swipeBox" v-if="descObj.answer && descObj.answer.answerImageList && descObj.answer.answerImageList.length>0">
          <van-swipe @change="onChange" :autoplay='3000'>
            <van-swipe-item v-for="(item, index) in descObj.answer.answerImageList" :key="index">
              <van-image
                class="img-swipe"
                fit="contain"
                :src="item"
              />
            </van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">{{ currentIndex+1 +'/' + descObj.answer.answerImageList.length }}</div>
            </template>
          </van-swipe>
        </div>
        <!-- 问题项图片 -->
        <div class="swipeBox" v-if="!descObj.answer && descObj.question && descObj.question.specImageList && descObj.question.specImageList.length>0">
          <van-swipe @change="onChange" :autoplay='3000'>
            <van-swipe-item v-for="(item, index) in descObj.question.specImageList" :key="index">
              <van-image
                class="img-swipe"
                fit="contain"
                :src="item"
              />
            </van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">{{ currentIndex+1 +'/' + descObj.question.specImageList.length }}</div>
            </template>
          </van-swipe>
        </div>

        <!-- 答案描述 -->
        <div class="showDesc_desc" v-if="descObj.answer">{{descObj.answer.answerDesc}}</div>
        <!-- 问题描述 -->
        <div class="showDesc_desc" v-else>{{descObj.question ? descObj.question.specDesc : ''}}</div>

        <!-- 答案名称 -->
        <div class="answerName" v-if="descObj.answer && descObj.answer.optionName">{{descObj.answer.optionName}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import { ref } from '@vue/composition-api'
export default {
  data () {
    return {
      show_desc: false,
      descObj: {}
    }
  }
  // setup(props, {root, emit}){
  //   let show_desc = ref(false)
  //   let descObj = ref({})

  //   const show = (obj) => {
  //     if(!obj){return}
  //     descObj.value = obj
  //     show_desc.value = true
  //     currentIndex.value = 0
  //   }

  //   let currentIndex = ref(0)
  //   const onChange = (index) => {
  //     currentIndex.value = index
  //   }

  //   return {
  //     show_desc,
  //     descObj,
  //     show,
  //     currentIndex,
  //     onChange,
  //   }
  // }
}
</script>

<style scoped lang='less'>
.descpopup{
  word-break: break-all;
}
.showDesc{
  box-sizing: border-box;
  padding: 20px 16px 0;
  .showDesc_title{
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 19px;
    box-sizing: border-box;
    padding-right: 40px;
  }
  .swipeBox{
    height: 214px;
    border-radius: 8px;
    margin-bottom: 16px;
    .img-swipe{
      width: 100%;
      height: 214px;
      background: #eee;
      border-radius: 8px;
      img{
        border-radius: 8px;
      }
    }
    .custom-indicator {
      position: absolute;
      right: 12px;
      bottom: 12px;
      box-sizing: border-box;
      padding: 2px 8px;
      opacity: 0.4;
      background: #000;
      color: #fff;
      border-radius: 10px;
      font-size: 12px;
      min-width: 32px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .showDesc_desc{
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin-bottom: 20px;
  }
  .answerName{
    background: #f7f7f7;
    border-radius: 8px;
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 19px;
    box-sizing: border-box;
    padding: 10px;
  }
}
.van-popup{
  z-index: 100000 !important;
}
/deep/ .img-swipe{
  img{
    border-radius: 8px !important;
  }
}
</style>
